import { useState } from "react";
import { errorMessage } from "../../lib/format";
import type { Session } from "../../platform/firebase";

export function LoginPage(props: {
  session: Session;
  denied: string | null;
  firebaseEmail: string | null;
  onSignOut: () => Promise<void>;
}) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const signIn = async () => {
    setBusy(true);
    setError(null);
    try {
      await props.session.signInWithGoogle();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login">
      <h1>golden</h1>
      <p className="muted">Scan-accuracy review</p>
      {props.denied ? (
        <>
          <p className="error">{props.denied}</p>
          <p>
            <button type="button" onClick={props.onSignOut}>
              Sign out{props.firebaseEmail ? ` ${props.firebaseEmail}` : ""}
            </button>
          </p>
        </>
      ) : (
        <p>
          <button type="button" className="button" onClick={signIn} disabled={busy}>
            Sign in with Google
          </button>
        </p>
      )}
      {error && <p className="error">{error}</p>}
    </main>
  );
}
